'use strict';
import easeOutExpo from '../../../_js/_helper';
import inlineSVG from 'inline-svg';
import autocomplete from 'devbridge-autocomplete';

export default class StoreMap {
    constructor() {
        if ($('#store-map').length > 0) {
            class Navigation {
                constructor(container, button, mblContainer, mblButton) {
                    this.container = container;
                    this.button = button;
                    this.mblContainer = mblContainer;
                    this.mblButton = mblButton;
                }
            }

            const firstLevelNav = new Navigation(
                $('.store-map-nav-first'),
                $('.store-map-nav-first li button'),
                $('.store-map-nav-mobile-category ul'),
                $('.store-map-nav-mobile-category li button')
            );

            const secondLevelNav = new Navigation(
                $('.store-map-nav-second'),
                $('.store-map-nav-second li button'),
                $('.store-map-nav-mobile-store > ul'),
                $('.store-map-nav-mobile-store li button')
            );

            const navInfo = $('.store-map-nav-info-desktop'),
                navInfoMobile = $('.store-map-nav-info-mobile'),
                floorSelect = $('.store-map-container-nav select'),
                categorieLabel = $('.store-map-nav-first-top'),
                storeHours = $('.store-map-nav-info-desktop-hours ul'),
                storeHoursMobile = $('.store-map-nav-info-mobile-hours ul'),
                legendDiv = $('.store-map-container-legend-img');
            let storeApi = $('#store-map').data('storeapiurl'),
                categoryApi = $('#store-map').data('categoriesapiurl'),
                floorApi = $('#store-map').data('floorapiurl'),
                storeArray = [],
                floorArray = [],
                categoriesToShow = {},
                defaultStore;

            // Add correct category colors to the store locations on the SVG map.
            function addCategoryColors() {
                setTimeout(() => {
                    $('#Map g:not(#White_areas_and_Floor):not(#Floor_Area) polygon,#Map g:not(#White_areas_and_Floor):not(#Floor_Area) path, #Map g:not(#White_areas_and_Floor):not(#Floor_Area) rect, #Map g:not(#White_areas_and_Floor):not(#Floor_Area) polyline').css('fill', 'white');
                    $('text').css('fill', 'black');
                    secondLevelNav.button.toArray().forEach(store => {
                        let location = $(store).data('store-location');
                        firstLevelNav.button.toArray().forEach(category => {
                            let color = $(category).data('category-color');
                            if ($(store).data('store-categories') === $(category).data('category-id')) {
                                $(`#${location} polygon, #${location} path, #${location} rect, #${location} polyline`).css('fill', color);
                            }
                        });
                    });
                }, 100);
            }

            function selectSearchStore(storeName, device) {
                let firstButton,
                    secondButton;
                if (device === 'mobile') {
                    firstButton = firstLevelNav.mblButton.toArray();
                    secondButton = secondLevelNav.mblButton.toArray();
                } else if (device === 'desktop') {
                    firstButton = firstLevelNav.button.toArray();
                    secondButton = secondLevelNav.button.toArray();
                }
                secondButton.forEach(store => {
                    if (!$(store).hasClass('store-map-nav-mobile-store-label')) {
                        if ($(store).data('store-name').toUpperCase() === storeName.toUpperCase()) {
                            firstButton.forEach(category => {
                                if ($(category).data('category-id') === $(store).data('store-categories')) {
                                    if ($(store).data('parent-floor') != $('li.option.selected').data('value')) {
                                        $('li.option').toArray().forEach(option => {
                                            if ($(option).data('value') === $(store).data('parent-floor')) {
                                                $(option).trigger('click');
                                                $(category).trigger('click');
                                                setTimeout(() => {
                                                    $(store).trigger('click');
                                                }, 100);
                                            }
                                        });
                                    } else {
                                        $(category).trigger('click');
                                        $(store).trigger('click');
                                    }
                                }
                            });
                        }
                    }
                });
            }

            function urlParam(name) {
                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
                if (results == null) {
                    return null;
                } else {
                    return decodeURI(results[1]) || 0;
                }
            }

            function init() {
                let html;
                // Ajax promise chain to make sure we have all content before running init().
                $.ajax({
                    url: storeApi
                }).done(data => {
                    data.value.sort((a, b) => {
                        if (a.StoreName > b.StoreName) {
                            return 1;
                        } else if (a.StoreName < b.StoreName) {
                            return -1;
                        }
                    }).forEach((item) => {
                        categoriesToShow[item.storecategories[0]] = '';

                        storeArray.push(item.StoreName);
                        html = `<li>
                        <button
                        data-store-name='${item.StoreName}'
                        data-store-summary="${item.StoreSummary.replace(/"/g, '&quot;')}"
                        data-store-location='${item.StoreLocationID}'
                        data-store-number='${item.StorePhone}'
                        ${item.StoreLogo ? 'data-store-logo="' + item.StoreLogo.Url + '"' : ''}
                        data-store-categories='${item.storecategories}'
                        data-parent-floor='${item.ParentId}'
                        data-email='${item.StoreEmail}'
                        data-store-id='${item.Id}'
                        ${item.StoreDetailPage ? 'data-store-website=' + item.StoreDetailPage : ''}
                        ${item.StoreOpeningHours ? 'data-store-hours=' + item.StoreOpeningHours : ''}>
                        ${item.StoreName}
                        </button>
                        </li>`;
                        secondLevelNav.container.append(html);
                        secondLevelNav.mblContainer.append(html);
                    });
                }).done(() => {
                    $.ajax({
                        url: categoryApi
                    }).done(data => {
                        data.value.sort((a, b) => {
                            if (a.Name > b.Name) {
                                return 1;
                            } else if (a.Name < b.Name) {
                                return -1;
                            }
                        }).forEach((item) => {

                            if (categoriesToShow[item.Id] === '') {
                                html = `<li><button ${item.Description ? 'data-category-color=' + item.Description.split(',')[0] : ''} data-category-id=${item.Id}><div class="icon"><img src="${item.Description ? item.Description.split(',')[1] : ''}"></div>${item.Title}</button></li>`;
                                firstLevelNav.container.append(html);
                                firstLevelNav.mblContainer.append(html);
                            }


                        });
                    }).done(() => {
                        $.ajax({
                            url: floorApi
                        }).done(data => {
                            // Create floor option markup and push to array for sorting.
                            data.value.forEach((item) => {
                                html = `<option value="${item.Id}" data-default-floor=${item.FloorDefault} data-floor-desktop=${item.FloorPlanDesktop.Url} data-floor-order=${item.FloorOrder} ${item.LegendDesktop ? 'data-floor-legend=' + item.LegendDesktop.Url : ''}>${item.FloorName}</option>`;
                                floorArray.push(html);

                            });


                            // Sort floors based on floor order and append the sorted floors to the page.
                            floorArray.sort((a, b) => {

                                return $(b).data('floor-order') - $(a).data('floor-order');
                            }).forEach(floor => {

                                floorSelect.append(floor);
                            });

                            $('option').toArray().forEach((option) => {
                                if ($(option).data('default-floor')) {
                                    $(option).attr('selected', true);
                                } else {
                                    $(option).attr('selected', false);
                                }
                            });

                        }).done(() => {

                            // Reasign button values as they were added with js.
                            firstLevelNav.button = $('.store-map-nav-first li button');
                            secondLevelNav.button = $('.store-map-nav-second li button');
                            secondLevelNav.mblButton = $('.store-map-nav-mobile-store li button');
                            firstLevelNav.mblButton = $('.store-map-nav-mobile-category li button');


                            // Append legend image based on floor.
                            if ($('option:selected').data('floor-legend')) {
                                legendDiv.append(`<img src=${$('option:selected').data('floor-legend')}>`);
                            }

                            // Convert map img tag to inline-svg for use later.
                            if ($('option:selected').data('floor-desktop')) {
                                $('.store-map-container-inner img').attr('src', $('option:selected').data('floor-desktop')).promise().done(() => {
                                    inlineSVG.init({
                                        svgSelector: 'img.svg', // The class attached to all images that should be inlined
                                        initClass: 'js-inlinesvg', // Class added to <html>
                                    });
                                });
                            }

                            // Add default floor title to map container.
                            $('.store-map-container-map-title').text($('option:selected').text());

                            // Make floor select box nice.
                            $('select').niceSelect();
                            if ($('#RetailStoreMapSearchBox').length > 0) {
                                $('.store-map-search-box').autocomplete({
                                    lookup: storeArray,
                                    onSelect: function () {
                                        $(window).width() > 1024 ? selectSearchStore($('.autocomplete-selected').text(), 'desktop') : selectSearchStore($('.autocomplete-selected').text(), 'mobile');
                                    }
                                });
                            }

                            // If there is a preselected category.
                            if ($('#preselected-store-category').length > 0) {
                                if ($(window).width() > 1024) {
                                    firstLevelNav.button.toArray().forEach(category => {
                                        if ($(category).data('category-id') === $('#preselected-store-category').data('preselected-store-category') && !$(category).hasClass('empty-category')) {
                                            $(category).trigger('click');
                                        }
                                    });
                                } else {
                                    firstLevelNav.mblButton.toArray().forEach(category => {
                                        if ($(category).data('category-id') === $('#preselected-store-category').data('preselected-store-category') && !$(category).hasClass('empty-category')) {
                                            $(category).trigger('click');
                                        }
                                    });
                                }
                            }

                            // If there is a preselected store.
                            setTimeout(() => {
                                if (urlParam('store-location')) {
                                    secondLevelNav.button.toArray().forEach(store => {
                                        if ($(store).data('store-location').replace('_', '') === urlParam('store-location')) {
                                            defaultStore = $(store).data('store-name');
                                            $(window).width() > 1024 ? selectSearchStore(defaultStore, 'desktop') : selectSearchStore(defaultStore, 'mobile');
                                        }
                                    });
                                } else if ($('#preselected-store-id').length > 0) {
                                    secondLevelNav.button.toArray().forEach(store => {
                                        if ($(store).data('store-id') === $('#preselected-store-id').data('preselected-store-id')) {
                                            defaultStore = $(store).data('store-name');
                                            $(window).width() > 1024 ? selectSearchStore(defaultStore, 'desktop') : selectSearchStore(defaultStore, 'mobile');
                                        }
                                    });
                                }
                            }, 150);

                        }).done(() => {
                            $('.store-map-loader-container').fadeOut();
                            addCategoryColors();
                        });
                    });
                });
            }

            // Run inintial init function when document is ready.
            $(document).ready(() => {
                init();
            });

            // Toggle nav function to toggle UI elements on page (Legend tab, Second level nav containing stores).
            function toggleNav(el, direction, slide) {
                if (direction === 'close') {
                    el.removeClass('active');

                    if (slide) {
                        el.slideUp(easeOutExpo);
                    }
                } else if (direction === 'open') {
                    el.addClass('active');

                    if (slide) {
                        el.slideDown(easeOutExpo);
                    }
                }
            }

            // Click handler when category is clicked.
            function categoryClickHandler(target, device, shops) {

                if (device === 'mobile') {
                    $('.store-map-nav-mobile-category button').removeClass('active-category');
                    $('.store-map-nav-mobile-category > div').removeClass('active');
                    $('.store-map-nav-mobile-store-top').html(`<button class="store-map-nav-mobile-store-label">Back</button><div class="store-map-nav-mobile-store-cat"><div class="icon"><img src="${target.find('img').attr('src')}"></div>${target.text()}</div>`);
                    firstLevelNav.mblContainer.slideUp(easeOutExpo);
                    navInfoMobile.slideUp(easeOutExpo).removeClass('active');
                    secondLevelNav.mblContainer.show();
                    $('.store-map-nav-mobile-store button').removeClass('active');
                } else if (device === 'desktop') {
                    if (target.hasClass('active-category') && target.hasClass('active')) {
                        addCategoryColors();
                    }
                    $('.store-map-nav-first button').removeClass('active-category').removeClass('active').attr('style', '');
                    categorieLabel.hide();
                }

                shops.toArray().forEach(function (item) {
                    if ($(item).data('store-categories') === target.data('category-id') || $(item).hasClass('store-map-nav-second-close')) {
                        $(item).show();
                    } else {
                        $(item).hide();
                    }
                });

                target.addClass('active-category');
            }

            // Shows all categories and hides category label.
            function showAllCategories(target) {
                categorieLabel.hide();

                target.toArray().forEach((item) => {
                    if (!$(item).hasClass('empty-category')) {
                        $(target).removeClass('active').removeClass('active-category');
                        $(item).css('display', 'flex');
                    }
                });

            }

            function highlightStore(location) {
                $('#Map g:not(#White_areas_and_Floor):not(#Floor_Area) polygon,#Map g:not(#White_areas_and_Floor):not(#Floor_Area) path, #Map g:not(#White_areas_and_Floor):not(#Floor_Area) rect, #Map g:not(#White_areas_and_Floor):not(#Floor_Area) polyline').css('fill', 'grey');
                $(`#${location} polygon, #${location} path, #${location} rect, #${location} polyline`).css('fill', $('.active-category').data('category-color'));
            }

            // Formats opening hour times for stores.
            function getFormatedTime(hour, minute) {
                let ampm = hour >= 12 ? 'pm' : 'am';

                hour = hour % 12;
                hour = hour ? hour : 12;
                minute = minute < 10 ? '0' + minute : minute;

                let strTime = `${hour}:${minute} ${ampm}`;
                return strTime;
            }

            function scrollTo(el, timing) {
                $('html, body').animate({
                    scrollTop: el.offset().top - 46
                }, timing);
            }

            // Click handler when store is clicked.
            function storeClickHandler(target, device) {
                if (target && !target.hasClass('store-map-nav-mobile-store-label')) {
                    let name = target.data('store-name'),
                        summary = target.data('store-summary'),
                        location = target.data('store-location'),
                        locationID = target.data('store-location'),
                        number = target.data('store-number'),
                        logo = target.data('store-logo');

                    if ($('option:selected').val() != target.data('parent-floor')) {
                        $('.nice-select li').toArray().forEach(option => {
                            if ($(option).data('value') === target.data('parent-floor')) {
                                $(option).trigger('click');
                            }
                        });
                        setTimeout(() => {
                            highlightStore(locationID);
                        }, 100);
                    }

                    if ($('.store-map-nav-info-desktop-store-info-website').length > 0) {
                        $('.store-map-nav-info-desktop-store-info-website').remove();
                    }

                    if ($('.store-map-nav-info-desktop-store-info-email').length > 0) {
                        $('.store-map-nav-info-desktop-store-info-email').remove();
                    }

                    if (target.data('store-hours')) {
                        $(`.store-map-nav-info-${device}-hours ul`).empty();
                        let html = '',
                            hours = target.data('store-hours');

                        if (!Object.entries)
                            Object.entries = function (obj) {
                                var ownProps = Object.keys(obj),
                                    i = ownProps.length,
                                    resArray = new Array(i); // preallocate the Array
                                while (i--)
                                    resArray[i] = [ownProps[i], obj[ownProps[i]]];

                                return resArray;
                            };

                        Object.entries(hours).forEach(([key, val]) => {
                            if (val['IsOpen'] === 'true') {
                                html = `<li><span>${key.substring(0, 3)}</span>${getFormatedTime(val['FromHour'], val['FromMinute'])} - ${getFormatedTime(val['ToHour'], val['ToMinute'])}`;
                                storeHours.append(html);
                                storeHoursMobile.append(html);
                            }
                        });
                    }

                    // Highlight store on map.
                    highlightStore(locationID);

                    if (target.data('email')) {
                        let email = `<a href="mailto:${target.data('email')}" alt="${name} email" class="store-map-nav-info-desktop-store-info-email">${target.data('email')}</a>`;
                        device === 'mobile' ? $('.store-map-nav-info-mobile-store-info').append(email) : $('.store-map-nav-info-desktop-store-info').append(email);
                    }                    

                    // Changing the text inside the store info div to the clicked stores text.
                    location = location.replace('_', '');
                    $(`.store-map-nav-info-${device}-summary`).html(summary);
                    $(`.store-map-nav-info-${device}-store-info-location`).text('Shop ' + location.replace(/^_+/i, ''));
                    $(`.store-map-nav-info-${device}-store-info-number`).html(`<a href="tel:${number}" alt="${name} phone number">${number}</a>`);
                    $(`.store-map-nav-info-${device}-logo`).empty();
                    if (logo) {
                        $(`.store-map-nav-info-${device}-logo`).append(`<img src=${logo}>`);
                    }

                    if (target.data('store-website')) {
                        let website = `<a href="${target.data('store-website')}" target="_blank" alt="${name} website" class="store-map-nav-info-desktop-store-info-website">VIEW STORE DETAIL PAGE</a>`;
                        device === 'mobile' ? $('.store-map-nav-info-mobile-summary').append(website) : $('.store-map-nav-info-desktop-summary').append(website);
                    }

                    if (device === 'desktop') {
                        $(`.store-map-nav-info-${device}-title`).text(name);
                        $('.store-map-nav-first button:not(.active-category):not(.store-map-nav-first-top-button)').hide();
                        $('.active-category').addClass('active');
                        $('.store-map-nav-first-top-button').show();
                        navInfo.slideDown(easeOutExpo).addClass('active');
                        categorieLabel.css('display', 'flex');
                    } else if (device === 'mobile') {
                        if (!target.hasClass('active') && navInfoMobile.css('display') === 'block') {
                            $('.store-map-nav-mobile-store button').removeClass('active');
                            target.addClass('active');
                            $('.store-map-nav-mobile-store li button').hide();
                            navInfoMobile.slideUp(easeOutExpo).removeClass('active');
                            setTimeout(() => {
                                target.parents('li').append(navInfoMobile);
                                navInfoMobile.slideDown(easeOutExpo).addClass('active');
                            }, 400);
                        } else if (!target.hasClass('active') && navInfoMobile.css('display') === 'none') {
                            $('.store-map-nav-mobile-store button').removeClass('active');
                            target.addClass('active');
                            $('.store-map-nav-mobile-store li button:not(.active):not(.store-map-nav-mobile-store-label)').hide();
                            target.parents('li').append(navInfoMobile);
                            navInfoMobile.slideDown(easeOutExpo).addClass('active');
                        } else if (target.hasClass('active')) {
                            target.removeClass('active');
                            // addCategoryColors();
                            navInfoMobile.slideUp(easeOutExpo).removeClass('active');
                        }
                    }

                } else {
                    navInfo.slideUp(easeOutExpo).removeClass('active');
                }
            }

            // Event listeners and corresponding actions.
            // Need to apply event listener to document due to all elements being injected via JS.
            $('#RetailStoreMapSearchBox form').on('submit', (e) => {
                e.preventDefault();
                $(window).width() > 1024 ? selectSearchStore($('.store-map-search-box').val(), 'desktop') : selectSearchStore($('.store-map-search-box').val(), 'mobile');
            });

            floorSelect.on('change', (e) => {
                addCategoryColors();
                $('.store-map-container-map-title').text($('option:selected').text());
                if ($('option:selected').data('floor-desktop')) {
                    $('.store-map-container-inner svg').remove();
                    $('.store-map-container-inner').append(`<img class="svg" src="${$('option:selected').data('floor-desktop')}">`);
                    inlineSVG.init({
                        svgSelector: 'img.svg', // the class attached to all images that should be inlined
                        initClass: 'js-inlinesvg', // class added to <html>
                    });
                }

            });

            $(document).on('click', '.store-map-container-nav-legend', () => {
                if (secondLevelNav.container.hasClass('active')) {
                    toggleNav(secondLevelNav.container, 'close');
                }
                toggleNav(legendDiv, 'open');
            });

            $(document).on('click', '.store-map-container-legend-img-close', () => {
                toggleNav(legendDiv, 'close');
            });

            if ($(window).width() > 1024) {
                // Laptop and above event listeners.

                categorieLabel.on('click', () => {
                    showAllCategories(firstLevelNav.button);
                    addCategoryColors();
                });

                $(document).on('click', '.store-map-nav button', () => {
                    storeClickHandler(false, 'desktop');
                });

                $(document).on('click', '.store-map-nav-first button', (e) => {
                    if (!$(e.target).closest('.store-map-nav-first button').hasClass('store-map-nav-first-top-button')) {
                        categoryClickHandler($(e.target).closest('.store-map-nav-first button'), 'desktop', $('.store-map-nav-second li button'));
                        toggleNav(secondLevelNav.container, 'open');
                    }

                    if (legendDiv.hasClass('active')) {
                        toggleNav(legendDiv, 'close');
                    }
                });

                $(document).on('click', '.store-map-nav-second button', (e) => {
                    toggleNav(secondLevelNav.container, 'close');
                    if (!$(e.target).hasClass('store-map-nav-second-close')) {
                        storeClickHandler($(e.target), 'desktop');
                    } else if ($(e.target).hasClass('active-category')) {
                        return null;
                    } else {
                        firstLevelNav.button.removeClass('active-category');
                    }
                });
            } else {
                // Tablet and below event listeners.
                $(document).on('click', '.store-map-nav-mobile-category > div', (e) => {
                    scrollTo($('.store-map-nav-mobile-category > div'), 800);
                    if (!$('.store-map-nav-info-mobile').hasClass('active')) {
                        addCategoryColors();
                    }
                    if ($(e.target).hasClass('active')) {
                        $(e.target).removeClass('active');
                        firstLevelNav.mblContainer.slideUp(easeOutExpo);
                    } else {
                        $(e.target).addClass('active');
                        firstLevelNav.mblContainer.slideDown(easeOutExpo);
                    }
                });

                $(document).on('click', '.store-map-nav-mobile-store-cat', (e) => {
                    let current = $(e.target).text();
                    firstLevelNav.mblButton.toArray().forEach(category => {
                        if ($(category).text() === current) {
                            $(category).trigger('click');
                        }
                    });
                });

                $(document).on('click', '.store-map-nav-mobile-store-label', () => {                    
                    addCategoryColors();
                    if ($('.store-map-nav-info-mobile').hasClass('active')) {
                        $('.store-map-nav-mobile-store-cat').trigger('click');
                    } else {
                        secondLevelNav.mblContainer.hide();
                        $('.store-map-nav-mobile-category > div').trigger('click');
                    }                    
                });

                $(document).on('click', '.store-map-nav-mobile-category button', (e) => {
                    categoryClickHandler($(e.target).closest('.store-map-nav-mobile-category button'), 'mobile', $('.store-map-nav-mobile-store button'));
                });

                $(document).on('click', '.store-map-nav-mobile-store button', (e) => {
                    storeClickHandler($(e.target), 'mobile');
                });
            }
        }
    }
}
